// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationGenerator-cls1_pHR","cls2":"CitationGenerator-cls2_iv- CitationGenerator-cls1_pHR"};